import VentetidBlock from './VentetidBlock';

globalThis.VentetidComponents = {
  VentetidBlock,
};
